<template>
  <section class="edit-student" v-if="student">
    <form data-vv-scope="pass">
      <p class="edit-student-instructions mb-0 pl-5">
        Use the form below to reset your student's password. We cannot show
        their current password for security reasons.
      </p>
      <v-row>
        <v-col cols="6">
          <v-text-field
            ref="password"
            v-model="password"
            name="password"
            label="Enter new student password"
            hint="Make sure that the password is 6 to 20 characters long"
            min="6"
            :append-icon="visible ? 'visibility' : 'visibility_off'"
            @click:append="visible = !visible"
            :error-messages="errors.collect('pass.password')"
            v-validate="'required|min:6|max:20'"
            data-vv-name="password"
            required
            :type="visible ? 'text' : 'password'"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="passwordConfirmation"
            name="password_confirmation"
            label="Re-enter new student password"
            hint="Make sure that this is the same as the password"
            min="6"
            :append-icon="visible ? 'visibility' : 'visibility_off'"
            @click:append="visible = !visible"
            :error-messages="errors.collect('pass.password_confirmation')"
            v-validate="'required|confirmed:password'"
            data-vv-name="password_confirmation"
            data-vv-as="password"
            required
            :type="visible ? 'text' : 'password'"
          />
        </v-col>
      </v-row>
    </form>
    <v-row justify="end">
      <v-btn
        :loading="loading"
        @click="deleteStudentFromClass"
        color="red darken-1"
        dark
      >
        un-enroll Student
      </v-btn>
      <v-btn
        @click="updateStudent"
        :disabled="!hasChanged"
        :loading="loading"
        color="primary"
      >
        Update
      </v-btn>
    </v-row>
  </section>
</template>
<script>
import ClassInvitation from '@/modules/class/models/ClassInvitation'
import Student from '@/modules/student/models/Student'
import Teacher from '@/modules/teacher/models/Teacher'
import { mapMutations } from 'vuex'

export default {
  name: 'EditStudent',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      password: null,
      passwordConfirmation: null,
      email: null,
      name: null,
      visible: false,
      loading: false,
      hasChanged: false
    }
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    classInvitationId: {
      type: String,
      required: true
    }
  },
  watch: {
    student() {
      this.name = this.student.class_invitations[0].name
      this.email = this.student.email
    },
    password() {
      this.hasChanged = true
    },
    name(val) {
      if (val != this.student.class_invitations[0].name) this.hasChanged = true
    },
    email(val) {
      if (val != this.student.email) this.hasChanged = true
    }
  },
  async created() {
    this.classInvitation = await ClassInvitation.query().find(
      this.classInvitationId
    )
  },
  async mounted() {
    await Student.dispatch('fetchStudentForTeacher', this.studentId)
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async deleteStudentFromClass() {
      this.loading = true
      try {
        await ClassInvitation.dispatch('deleteClassInvitation', {
          classInvitationId: this.classInvitationId
        })

        this.showSnackbar('Student deleted successfuly.')
      } catch (error) {
        this.showErrorSnackbar('Something bad happened. Try again')
      }
      this.loading = false
      this.$emit('close')
    },
    async updateStudent() {
      // let result = await this.$validator.validateAll('creds')
      if (this.password) {
        let passresult = await this.$validator.validateAll('pass')
        if (!passresult) return
      }
      // if (!result) {
      //   return // there are errors
      // }

      this.loading = true
      const payload = {
        //name: this.name,
        password: this.password,
        email: this.email,
        id: this.studentId,
        classInvitationId: this.classInvitationId
      }

      try {
        // console.log('before')
        await Teacher.dispatch('updateStudentInfo', {
          payload: payload
        })
        // console.log('after')
        // ClassInvitation.update({
        //   id: this.classInvitationId,
        //   name: this.name
        // })
        Student.update({
          id: this.studentId,
          email: this.email
        })
        this.password = ''
        this.passwordConfirmation = ''

        this.hasChanged = false
        this.showSnackbar('Student updated successfuly.')
      } catch (error) {
        // console.log('hahahaha')
        // console.log(error)
        this.showErrorSnackbar('Something bad happened. Try again')
      }
      this.loading = false
    }
  },
  computed: {
    student() {
      return Student.query()
        .with('class_invitations', query => {
          query.where('id', this.classInvitationId)
        })
        .find(this.studentId)
    }
  }
}
</script>

<style lang="scss">
.edit-student-instructions {
  margin-left: 25px !important;
}
</style>
